import { t } from '@/i18n';
import { computed } from 'vue'

export enum ReviewStatus {
  NEEDS_REVIEW = 'needs_review',
  IN_PROGRESS = 'in_progress',
  APPROVED = 'approved',
  DISAPPROVED = 'disapproved',
  NO_STATUS = '',
}

export const ReviewStatusLabelMap = {
  [ReviewStatus.NEEDS_REVIEW]: computed(() => t('enum.needReview')),
  [ReviewStatus.IN_PROGRESS]: computed(() => t('enum.inProgress')),
  [ReviewStatus.APPROVED]: computed(() => t('enum.approved')),
  [ReviewStatus.DISAPPROVED]: computed(() => t('enum.disapproved')),
  [ReviewStatus.NO_STATUS]: computed(() => t('enum.noStatus')),
}
